__webpack_require__.p = "/mi-assets/mi-static/mi-shop-renderer-2/web-rel-26.7.1-07132026330/_next/";